module.exports = __webpack_public_path__ + "static/media/console-graphic.4c0831bf.svg";